/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_S4_Li5Inputs */

const en_guide_what_is_json_s4_li5 = /** @type {(inputs: Guide_What_Is_Json_S4_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>Logging</strong>: Structured logging in JSON format makes logs searchable and parseable`)
};

const ko_guide_what_is_json_s4_li5 = /** @type {(inputs: Guide_What_Is_Json_S4_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>로깅</strong>: JSON 포맷의 구조화된 로깅으로 로그를 검색하고 파싱할 수 있습니다`)
};

const ja_guide_what_is_json_s4_li5 = /** @type {(inputs: Guide_What_Is_Json_S4_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>ログ</strong>: JSON形式の構造化ログにより、ログの検索や解析が容易になります`)
};

/**
* | output |
* | --- |
* | "<strong>Logging</strong>: Structured logging in JSON format makes logs searchable and parseable" |
*
* @param {Guide_What_Is_Json_S4_Li5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_s4_li5 = /** @type {((inputs?: Guide_What_Is_Json_S4_Li5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_S4_Li5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_s4_li5(inputs)
	if (locale === "ko") return ko_guide_what_is_json_s4_li5(inputs)
	return ja_guide_what_is_json_s4_li5(inputs)
});